import { gql, TypedDocumentNode } from '@apollo/client'

import { AD_UNIT_FOR_TABLE_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const GET_AD_UNITS_FOR_TABLE: TypedDocumentNode<Data, Variables> = gql`
  ${AD_UNIT_FOR_TABLE_FRAGMENT}

  query getAdUnitsForTable(
    $first: Int
    $last: Int
    $workspaceId: ID!
    $terms: [String!]
    $sort: AdUnitSortInput
  ) {
    adUnits(first: $first, last: $last, workspaceId: $workspaceId, terms: $terms, sort: $sort) {
      nodes {
        ...AdUnitForTableFragment
      }

      totalCount
    }
  }
`
